'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var dirFlat = require('./dir-flat.js');

var flatToShard = require('./flat-to-shard.js');

var dir = require('./dir.js');

var toPathComponents = require('./utils/to-path-components.js');

function addToTree(_x6, _x7, _x8) {
  return _addToTree.apply(this, arguments);
}

function _addToTree() {
  _addToTree = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(elem, tree, options) {
    var pathElems, lastIndex, parent, currentPath, i, pathElem, last, dir$1;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            pathElems = toPathComponents(elem.path || '');
            lastIndex = pathElems.length - 1;
            parent = tree;
            currentPath = '';
            i = 0;

          case 5:
            if (!(i < pathElems.length)) {
              _context3.next = 30;
              break;
            }

            pathElem = pathElems[i];
            currentPath += "".concat(currentPath ? '/' : '').concat(pathElem);
            last = i === lastIndex;
            parent.dirty = true;
            parent.cid = undefined;
            parent.size = undefined;

            if (!last) {
              _context3.next = 20;
              break;
            }

            _context3.next = 15;
            return parent.put(pathElem, elem);

          case 15:
            _context3.next = 17;
            return flatToShard(null, parent, options.shardSplitThreshold, options);

          case 17:
            tree = _context3.sent;
            _context3.next = 27;
            break;

          case 20:
            _context3.next = 22;
            return parent.get(pathElem);

          case 22:
            dir$1 = _context3.sent;

            if (!dir$1 || !(dir$1 instanceof dir)) {
              dir$1 = new dirFlat({
                root: false,
                dir: true,
                parent: parent,
                parentKey: pathElem,
                path: currentPath,
                dirty: true,
                flat: true,
                mtime: dir$1 && dir$1.unixfs && dir$1.unixfs.mtime,
                mode: dir$1 && dir$1.unixfs && dir$1.unixfs.mode
              }, options);
            }

            _context3.next = 26;
            return parent.put(pathElem, dir$1);

          case 26:
            parent = dir$1;

          case 27:
            i++;
            _context3.next = 5;
            break;

          case 30:
            return _context3.abrupt("return", tree);

          case 31:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _addToTree.apply(this, arguments);
}

function flushAndYield(_x, _x2) {
  return _flushAndYield.apply(this, arguments);
}

function _flushAndYield() {
  _flushAndYield = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tree, blockstore) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (tree instanceof dir) {
              _context.next = 5;
              break;
            }

            if (!(tree && tree.unixfs && tree.unixfs.isDirectory())) {
              _context.next = 4;
              break;
            }

            _context.next = 4;
            return tree;

          case 4:
            return _context.abrupt("return");

          case 5:
            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(tree.flush(blockstore)), _awaitAsyncGenerator), "t0", 6);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _flushAndYield.apply(this, arguments);
}

function treeBuilder(_x3, _x4, _x5) {
  return _treeBuilder.apply(this, arguments);
}

function _treeBuilder() {
  _treeBuilder = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source, block, options) {
    var tree, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, unwrapped;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            tree = new dirFlat({
              root: true,
              dir: true,
              path: '',
              dirty: true,
              flat: true
            }, options);
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 3;
            _iterator = _asyncIterator(source);

          case 5:
            _context2.next = 7;
            return _awaitAsyncGenerator(_iterator.next());

          case 7:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 20;
              break;
            }

            entry = _step.value;

            if (entry) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("continue", 17);

          case 11:
            _context2.next = 13;
            return _awaitAsyncGenerator(addToTree(entry, tree, options));

          case 13:
            tree = _context2.sent;

            if (!(!entry.unixfs || !entry.unixfs.isDirectory())) {
              _context2.next = 17;
              break;
            }

            _context2.next = 17;
            return entry;

          case 17:
            _iteratorAbruptCompletion = false;
            _context2.next = 5;
            break;

          case 20:
            _context2.next = 26;
            break;

          case 22:
            _context2.prev = 22;
            _context2.t0 = _context2["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 26:
            _context2.prev = 26;
            _context2.prev = 27;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 31;
              break;
            }

            _context2.next = 31;
            return _awaitAsyncGenerator(_iterator.return());

          case 31:
            _context2.prev = 31;

            if (!_didIteratorError) {
              _context2.next = 34;
              break;
            }

            throw _iteratorError;

          case 34:
            return _context2.finish(31);

          case 35:
            return _context2.finish(26);

          case 36:
            if (!options.wrapWithDirectory) {
              _context2.next = 40;
              break;
            }

            return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(flushAndYield(tree, block)), _awaitAsyncGenerator), "t1", 38);

          case 38:
            _context2.next = 70;
            break;

          case 40:
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context2.prev = 42;
            _iterator2 = _asyncIterator(tree.eachChildSeries());

          case 44:
            _context2.next = 46;
            return _awaitAsyncGenerator(_iterator2.next());

          case 46:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context2.sent).done)) {
              _context2.next = 54;
              break;
            }

            unwrapped = _step2.value;

            if (unwrapped) {
              _context2.next = 50;
              break;
            }

            return _context2.abrupt("continue", 51);

          case 50:
            return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(flushAndYield(unwrapped.child, block)), _awaitAsyncGenerator), "t2", 51);

          case 51:
            _iteratorAbruptCompletion2 = false;
            _context2.next = 44;
            break;

          case 54:
            _context2.next = 60;
            break;

          case 56:
            _context2.prev = 56;
            _context2.t3 = _context2["catch"](42);
            _didIteratorError2 = true;
            _iteratorError2 = _context2.t3;

          case 60:
            _context2.prev = 60;
            _context2.prev = 61;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context2.next = 65;
              break;
            }

            _context2.next = 65;
            return _awaitAsyncGenerator(_iterator2.return());

          case 65:
            _context2.prev = 65;

            if (!_didIteratorError2) {
              _context2.next = 68;
              break;
            }

            throw _iteratorError2;

          case 68:
            return _context2.finish(65);

          case 69:
            return _context2.finish(60);

          case 70:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 22, 26, 36], [27,, 31, 35], [42, 56, 60, 70], [61,, 65, 69]]);
  }));
  return _treeBuilder.apply(this, arguments);
}

module.exports = treeBuilder;